"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DrupalLikertNugget = _interopRequireDefault(require("./DrupalLikertNugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _LikertNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/LikertNugget"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Constants = require("../../../constants/Constants");

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));

var _RemoveCircle = _interopRequireDefault(require("@material-ui/icons/RemoveCircle"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'likertContainer_';

var DrupalLikertNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalLikertNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalLikertNugget);

  function DrupalLikertNugget(_props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalLikertNugget);
    _this = _super.call(this, _props, context, _props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getResult", function () {
      var checkedBoxes = _this.state.checkedBoxes;
      var valueToReturn = 0;

      if (checkedBoxes.length > 0) {
        checkedBoxes.forEach(function (box) {
          valueToReturn += box.value / checkedBoxes.length;
        });
      }

      return valueToReturn.toFixed(1);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkOption", function (checkedOption) {
      var nugget = _this.state.content[_this.props.id];
      var middleIndex = Math.floor(checkedOption.optionCount / 2);
      var boxValue = (checkedOption.boxIndex - middleIndex) / middleIndex;

      var ids = _this.state.checkedBoxes.slice();

      var alreadyChecked = ids.find(function (singleId) {
        return singleId.index === checkedOption.index && singleId.id !== checkedOption.id;
      });

      if (alreadyChecked) {
        var index = ids.findIndex(function (option) {
          return option.id === alreadyChecked.id;
        });
        (0, _ArrayHelper.removeElementAtPosition)(ids, index);
      }

      var el = ids.find(function (singleId) {
        return singleId.id === checkedOption.id;
      });

      if (el) {
        if (!_this.props.inWizardContainer) {
          var _index = ids.findIndex(function (option) {
            return option.id === el.id;
          });

          (0, _ArrayHelper.removeElementAtPosition)(ids, _index);
        }
      } else {
        ids.push({
          id: checkedOption.id,
          uuid: checkedOption.uuid,
          index: checkedOption.index,
          value: boxValue,
          boxIndex: checkedOption.boxIndex
        });
      }

      _this.setState({
        checkedBoxes: ids
      }, function () {
        // console.log('checkOption', ids, nugget.likertOptions)
        if (ids.length === nugget.likertOptions.length) {
          _this.props.markAsRead(_this.props.id); // save single options if datastore pathes for the likertoptions are configured


          ids.forEach(function (id, ind) {
            var path = nugget.likertOptions[ind].dataStorePath;

            if (path && path.indexOf(_config["default"].dataStorePathKey) === -1) {
              if (path) _DataStore["default"].setSingleData(path, boxValue); // changed value to boxValue
            } else if (path && path.indexOf(_config["default"].dataStorePathKey) > -1) {
              if (path) _DataStore["default"].setSingleData(path, id.boxIndex + 1);
            }
          }); // persist all selected data for showPreviousResultsOnReopen

          if (nugget.showPreviousResultsOnReopen && nugget.dataStorePath) {
            var path = "".concat(nugget.dataStorePath, "_persist");

            _DataStore["default"].setSingleData(path, ids);
          }

          if (nugget.dataStorePath) {
            var result = _this.getResult();

            _DataStore["default"].setSingleData(nugget.dataStorePath, result);
          }
        }
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderLikertOption", function (option, index, isMobile) {
      var EqueoCheckBox = (0, _withStyles["default"])({
        root: {
          color: _config["default"].useTileBackgroundColorInTile && _this.props.forcedUIColor ? _this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground,
          backgroundColor: 'white',
          '&$checked': {
            color: _config["default"].useTileBackgroundColorInTile && _this.props.forcedUIColor ? _this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground
          },
          '&:focus, &:hover, &$active': {
            backgroundColor: 'white'
          }
        }
      })(function (props) {
        return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], (0, _extends2["default"])({
          color: "default"
        }, props));
      });
      var optionCount = option.optionCount;
      var minText = option.minText;
      var maxText = option.maxText;
      var renderOptions = [];

      for (var i = 0; i < optionCount; i++) {
        var title = void 0;
        var className = _DrupalLikertNugget["default"].innerBox;

        if (i === 0) {
          title = minText;
          className = _DrupalLikertNugget["default"].leftBox;
        } else if (i === optionCount - 1) {
          title = maxText;
          className = _DrupalLikertNugget["default"].rightBox;
        }

        renderOptions.push({
          title: title,
          id: "".concat(index, "_").concat(i),
          index: index,
          optionCount: optionCount,
          uuid: option.uuid,
          weight: option.weight
        });
      }

      var isMobileDevice = !_DeviceInfoHelper["default"].isBrowser() || _DeviceInfoHelper["default"].isBrowser() && window.innerWidth < _Constants.SMARTPHONE_WIDTH_PORTRAIT_BREAKPOINT;

      var nugget = _this.state.content[_this.props.id];
      var containerClassName = _DrupalLikertNugget["default"].optionContainer;

      if (isMobile) {
        containerClassName = _DrupalLikertNugget["default"].optionContainerMobile;
      }

      if (isMobileDevice && !isMobile) {
        containerClassName += "".concat(_DrupalLikertNugget["default"].optionContainerMobile, " ").concat(_DrupalLikertNugget["default"].forcedDesktop);
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClassName
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobileDevice ? _DrupalLikertNugget["default"].optionQuestionMobile : _DrupalLikertNugget["default"].optionQuestion
      }, option.question), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLikertNugget["default"].optionBoxContainer
      }, !_config["default"].useNewLikertDesign && !isMobile && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLikertNugget["default"].optionLine
      }), /*#__PURE__*/_react["default"].createElement("div", null, renderOptions.map(function (singleOption, index, array) {
        var isChecked = Boolean(_this.state.checkedBoxes.find(function (checkedId) {
          return checkedId.id === singleOption.id;
        }));
        singleOption.boxIndex = index;
        var boxClassName = _DrupalLikertNugget["default"].box;

        if (isChecked) {
          boxClassName += " ".concat(_DrupalLikertNugget["default"].boxChecked);
        } else {
          boxClassName += " ".concat(_DrupalLikertNugget["default"].boxUnchecked);
        }

        if (index === 0) {
          boxClassName += " ".concat(_DrupalLikertNugget["default"].checkBoxLeft);
        } else if (index === renderOptions.length - 1) {
          boxClassName += " ".concat(_DrupalLikertNugget["default"].checkBoxRight);
        } // how many icons should be rendered


        var middleIndex = (array.length - 1) / 2;
        var nIcons = index - middleIndex; // determine the icon to be rendered and get an array with floor(|nIcons|) of the icon

        var icons = nIcons < 0 ? new Array(Math.abs(Math.floor(nIcons))).fill( /*#__PURE__*/_react["default"].createElement(_RemoveCircle["default"], {
          style: {
            color: 'red',
            width: '0.75em'
          }
        })) : new Array(Math.abs(Math.floor(nIcons))).fill( /*#__PURE__*/_react["default"].createElement(_AddCircle["default"], {
          style: {
            color: 'green',
            width: '0.75em'
          }
        }));
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: "".concat(100 / optionCount, "%")
          },
          className: _DrupalLikertNugget["default"].singleOptionBoxContainer
        }, _config["default"].useNewLikertDesign && /*#__PURE__*/_react["default"].createElement("div", {
          id: singleOption.id,
          className: boxClassName,
          onClick: function onClick() {
            return _this.checkOption(singleOption);
          }
        }, index + 1), !_config["default"].useNewLikertDesign && /*#__PURE__*/_react["default"].createElement(EqueoCheckBox, {
          classes: {
            root: _DrupalLikertNugget["default"].checkBoxRoot
          },
          id: singleOption.id,
          checked: isChecked,
          onClick: function onClick() {
            return _this.checkOption(singleOption);
          }
        }), _config["default"].isErgoApp && icons.map(function (icon) {
          return icon;
        }), singleOption.title ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalLikertNugget["default"].optionTitle
        }, singleOption.title) : null, _config["default"].showLikertOptionIcons ? /*#__PURE__*/_react["default"].createElement("div", null) : null);
      }))), isMobile ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLikertNugget["default"].buttonContainer
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: _this.state.mobilePageIndex === 0 ? _DrupalLikertNugget["default"].backButtonDisabled : _DrupalLikertNugget["default"].backButton,
        disabled: _this.state.mobilePageIndex === 0,
        onClick: function onClick() {
          return _this.setState({
            mobilePageIndex: _this.state.mobilePageIndex - 1
          });
        }
      }, 'Zurück'), _this.state.mobilePageIndex < nugget.likertOptions.length - (nugget.showResult ? 0 : 1) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: _this.state.mobilePageIndex === _this.state.checkedBoxes.length ? _DrupalLikertNugget["default"].nextButtonDisabled : _DrupalLikertNugget["default"].nextButton,
        disabled: _this.state.mobilePageIndex === _this.state.checkedBoxes.length,
        onClick: function onClick() {
          return _this.goToNextPage();
        }
      }, 'Weiter'), _this.state.mobilePageIndex === nugget.likertOptions.length - 1 && nugget.postPath && !nugget.showResult && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: _this.state.mobilePageIndex === _this.state.checkedBoxes.length ? _DrupalLikertNugget["default"].nextButtonDisabled : _DrupalLikertNugget["default"].nextButton,
        disabled: _this.state.checkedBoxes.length === 0,
        onClick: function onClick() {
          return _this.sendDataToPostPath();
        }
      }, 'Absenden')) : null));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goToNextPage", function () {
      var nugget = _this.state.content[_this.props.id];

      if (nugget.showResult && _this.state.mobilePageIndex < nugget.likertOptions.length || !nugget.showResult && _this.state.mobilePageIndex < nugget.likertOptions.length - 1) {
        _this.setState({
          mobilePageIndex: _this.state.mobilePageIndex + 1
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderSlider", function () {
      var color = _config["default"].useTileBackgroundColorInTile && _this.props.forcedUIColor ? _this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground;

      if (_this.props.lectureBackgroundColor && _cssConstants["default"].colorMap && _cssConstants["default"].colorMap[_this.props.lectureBackgroundColor]) {
        color = _cssConstants["default"].colorMap[_this.props.lectureBackgroundColor];
      }

      var EqueoSlider = (0, _withStyles["default"])({
        root: {
          color: color,
          height: 8
        },
        thumb: {
          height: 24,
          width: 24,
          backgroundColor: '#fff',
          border: '2px solid currentColor',
          borderRadius: 0,
          marginTop: -8,
          marginLeft: -12,
          '&:focus, &:hover, &$active': {
            boxShadow: 'inherit'
          }
        },
        active: {},
        valueLabel: {
          left: 'calc(-50% + 4px)',
          color: color,
          fontSize: 0
        },
        track: {
          color: color,
          height: 8,
          borderRadius: 4
        },
        rail: {
          opacity: 1,
          color: color,
          height: 8,
          borderRadius: 4
        }
      })(_Slider["default"]);
      var nugget = _this.state.content[_this.props.id];

      var result = _this.getResult();

      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        className: _DrupalLikertNugget["default"].resultLabel
      }, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: nugget.minResultName
        }
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: true,
        className: _DrupalLikertNugget["default"].sliderContainer
      }, /*#__PURE__*/_react["default"].createElement(EqueoSlider, {
        valueLabelDisplay: 'on',
        min: -1,
        max: 1,
        value: result,
        onChange: function onChange() {}
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        className: _DrupalLikertNugget["default"].resultLabel
      }, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: nugget.maxResultName
        }
      })));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderDesktopVersion", function () {
      var nugget = _this.state.content[_this.props.id];
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, nugget.likertOptions && nugget.likertOptions.length > 0 && nugget.likertOptions.map(function (option, index) {
        return _this.renderLikertOption(option, index, false);
      }), nugget.showResult && _this.state.checkedBoxes.length < nugget.likertOptions.length && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLikertNugget["default"].infoText
      }, nugget.likertOptions.length === 1 ? 'Bitte wählen Sie eine Antwort, um ein Resultat zu erhalten' : 'Bitte wählen Sie zu jeder Option eine Antwort, um ein Resultat zu erhalten'), nugget.showResult && _this.state.checkedBoxes.length === nugget.likertOptions.length ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLikertNugget["default"].resultContainer
      }, /*#__PURE__*/_react["default"].createElement("hr", {
        className: _DrupalLikertNugget["default"].divider
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLikertNugget["default"].optionQuestion
      }, nugget.resultTitle ? nugget.resultTitle : 'Auswertung'), _this.renderSlider(), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: _DrupalLikertNugget["default"].resetButon,
        onClick: function onClick() {
          return _this.setState({
            checkedBoxes: []
          });
        }
      }, 'Auswahl zurücksetzen')) : null);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderMobileVersion", function () {
      var nugget = _this.state.content[_this.props.id];
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
        disabled: true,
        index: _this.state.mobilePageIndex
      }, nugget.likertOptions && nugget.likertOptions.length > 0 && nugget.likertOptions.map(function (option, index) {
        return _this.renderLikertOption(option, index, true);
      }), nugget.showResult ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLikertNugget["default"].resultContainer
      }, /*#__PURE__*/_react["default"].createElement("hr", {
        className: _DrupalLikertNugget["default"].divider
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLikertNugget["default"].optionQuestion
      }, nugget.resultTitle ? nugget.resultTitle : 'Auswertung'), _this.renderSlider(), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: _DrupalLikertNugget["default"].resetButon,
        onClick: function onClick() {
          return _this.setState({
            checkedBoxes: [],
            mobilePageIndex: 0
          });
        }
      }, 'Auswahl zurücksetzen')) : /*#__PURE__*/_react["default"].createElement("div", null)));
    });
    _this.state = _objectSpread({
      waitingForActivation: false,
      waitingForDelete: false,
      checkedBoxes: [],
      mobilePageIndex: 0
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;

    _this.props.registerNugget(_this.props.id, _LikertNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalLikertNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalLikertNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nugget = this.state.content[this.props.id];
      this.registerNuggetPosition(this.props.id, _LikertNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      if (nugget.showPreviousResultsOnReopen && nugget.dataStorePath) {
        var path = "".concat(nugget.dataStorePath, "_persist");

        var ids = _DataStore["default"].getElementByPathImmediately(path);

        if (ids) this.setState({
          checkedBoxes: ids
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalLikertNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {LikertNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var isMobile = !_DeviceInfoHelper["default"].isBrowser() || _DeviceInfoHelper["default"].isBrowser() && window.innerWidth < _Constants.SMARTPHONE_WIDTH_PORTRAIT_BREAKPOINT;

      if (this.props.inWizardContainer) {
        var isStepDone = true;
        nugget.likertOptions.forEach(function (option, ind) {
          if (option.isMandatory && !_this2.state.checkedBoxes.find(function (box) {
            return box.index === ind;
          })) isStepDone = false;
        });
        this.props.setStepDone(isStepDone);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "likertContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inWizardContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "LikertNugget_".concat(this.props.id, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.showTitle && (_config["default"].targetTag !== "visitberlin" ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.inGalleryContainer ? 'titleSmall' : 'title')
      }, nugget.title) : /*#__PURE__*/_react["default"].createElement("h1", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title)), nugget.info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: 'info',
        style: {
          paddingBottom: '20px'
        },
        dangerouslySetInnerHTML: {
          __html: nugget.info
        }
      }) : null, isMobile && !nugget.forceOnOnePage ? this.renderMobileVersion() : this.renderDesktopVersion()), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inWizardContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalLikertNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalLikertNugget;
DrupalLikertNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inWizardContainer: _propTypes["default"].bool.isRequired,
  setStepDone: _propTypes["default"].func,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  registerSendFunc: _propTypes["default"].func,
  lectureBackgroundColor: _propTypes["default"].string,
  setLike: _propTypes["default"].func
};
DrupalLikertNugget.defaultProps = {
  id: null
};